export default __webpack_public_path__ + "static/media/aint-no-thang.cc66b3da.gif";